import { PropsWithChildren } from "react";
import classNames from "classnames";

import { Colors } from "@/constants/colors";
import { useGender } from "@/utils/GenderProvider";

import "./styles.css";

interface CircularProgressbarProps {
    progress: number;
    diameter?: number;
    strokeWidth?: number;
    trailColor?: string;
    pathColor?: string;
    className?: string;
}
const CircularProgressbar = ({
    progress,
    diameter = 40,
    strokeWidth = 3,
    trailColor,
    pathColor,
    children,
    className,
}: PropsWithChildren<CircularProgressbarProps>) => {
    const { isFemale } = useGender();

    const style = {
        "--progress": progress,
        "--diameter": `${diameter}px`,
        "--stroke-width": `${strokeWidth}px`,
        "--trail-color": trailColor ?? (isFemale ? Colors.NEUTRAL_COOL_GREY_300 : Colors.BLACK_200),
        "--path-color": pathColor ?? (isFemale ? Colors.WARM_TANGERINE_500 : Colors.LIME_200),
    } as React.CSSProperties;

    const innerContent = children ?? (
        <div className="absolute bottom-[50%] left-[50%] -translate-x-[50%] translate-y-[50%] text-zing-10-12 font-semibold text-white female:text-black">
            {progress}%
        </div>
    );

    return (
        <div className={classNames("relative w-fit", className)}>
            <svg
                width={diameter}
                height={diameter}
                viewBox={`0 0 ${diameter} ${diameter}`}
                style={style}
                className="zing-circular-progress"
            >
                <circle className="bg"></circle>
                <circle className="fg"></circle>
            </svg>
            {innerContent}
        </div>
    );
};

export default CircularProgressbar;
